module.exports = __webpack_public_path__ + "static/media/cover_page.37c74ea9.png";